/**
 * 統一日誌工具
 * 生產環境不輸出敏感信息
 */

const isDev = import.meta.env.DEV
const enableDebug = import.meta.env.VITE_ENABLE_DEBUG === 'true'

// 是否允許輸出調試信息
const canLog = isDev || enableDebug

/**
 * 移除敏感信息（地址、推薦碼等）
 */
function sanitizeData(data) {
  if (!data) return data
  
  if (typeof data === 'string') {
    // 如果包含地址格式，進行遮罩
    if (data.startsWith('0x') && data.length === 42) {
      return `${data.slice(0, 6)}...${data.slice(-4)}`
    }
    return data
  }
  
  if (Array.isArray(data)) {
    return data.map(item => sanitizeData(item))
  }
  
  if (typeof data === 'object') {
    const sanitized = {}
    const sensitiveKeys = [
      'address', 'wallet_address', 'walletAddress',
      'referrer_address', 'referee_address',
      'referral_code', 'referralCode',
      'password', 'secret', 'key',
      'apiKey', 'api_key',
      'token', 'auth'
    ]
    
    for (const [key, value] of Object.entries(data)) {
      const lowerKey = key.toLowerCase()
      const isSensitive = sensitiveKeys.some(sk => lowerKey.includes(sk))
      
      if (isSensitive && typeof value === 'string') {
        if (value.startsWith('0x') && value.length === 42) {
          sanitized[key] = `${value.slice(0, 6)}...${value.slice(-4)}`
        } else {
          sanitized[key] = '***'
        }
      } else if (typeof value === 'object') {
        sanitized[key] = sanitizeData(value)
      } else {
        sanitized[key] = value
      }
    }
    
    return sanitized
  }
  
  return data
}

/**
 * 安全日誌輸出（生產環境自動移除敏感信息）
 */
export const logger = {
  log(...args) {
    if (!canLog) return
    console.log(...args.map(arg => sanitizeData(arg)))
  },
  
  warn(...args) {
    if (!canLog) return
    console.warn(...args.map(arg => sanitizeData(arg)))
  },
  
  error(...args) {
    // 錯誤日誌始終輸出，但移除敏感信息
    console.error(...args.map(arg => sanitizeData(arg)))
  },
  
  info(...args) {
    if (!canLog) return
    console.info(...args.map(arg => sanitizeData(arg)))
  },
  
  debug(...args) {
    if (!canLog) return
    console.debug(...args.map(arg => sanitizeData(arg)))
  }
}

